var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5L8 9H16L12 20.5Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3H7L2 9L8 9L10 3Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3H17L22 9L16 9L14 3Z",
    fill: ""
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.49758 9H21.4976M9.99758 3L7.99758 9L11.9976 20.5L15.9976 9L13.9976 3M12.6122 20.2625L21.5708 9.51215C21.7226 9.32995 21.7985 9.23885 21.8275 9.13717C21.8531 9.04751 21.8531 8.95249 21.8275 8.86283C21.7985 8.76114 21.7226 8.67005 21.5708 8.48785L17.2375 3.28785C17.1493 3.18204 17.1052 3.12914 17.0512 3.09111C17.0033 3.05741 16.9498 3.03238 16.8933 3.01717C16.8295 3 16.7606 3 16.6229 3H7.37228C7.23455 3 7.16569 3 7.10187 3.01717C7.04533 3.03238 6.99189 3.05741 6.94401 3.09111C6.88997 3.12914 6.84588 3.18204 6.75771 3.28785L2.42437 8.48785C2.27254 8.67004 2.19663 8.76114 2.16762 8.86283C2.14204 8.95249 2.14204 9.04751 2.16762 9.13716C2.19663 9.23885 2.27254 9.32995 2.42437 9.51215L11.383 20.2625C11.5941 20.5158 11.6996 20.6424 11.8259 20.6886C11.9368 20.7291 12.0584 20.7291 12.1692 20.6886C12.2956 20.6424 12.4011 20.5158 12.6122 20.2625Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSubscription);
export default __webpack_public_path__ + "static/media/menu-subscription.b9e637f60fac3978638998c6e52dee27.svg";
export { ForwardRef as ReactComponent };